import { useState, useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { intersection_threshold, url } from '../../base/Variables'
import { ProductCard, ProductPlaceholder } from '../index'
import { useDispatch } from 'react-redux'
import { setSuggestedProduct } from '../../redux/AppSlice'
import { useNavigate } from 'react-router-dom'
import { LazyAxios } from '../../base'

function TopSellingProduct() {
  const [loading, setLoading] = useState(true)
  const top_selling_product = useSelector((state) => state.appSlice.top_selling_product)
  const cart_item_list = useSelector((state) => state.cartSlice.cart_item_list)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const componentRef = useRef(null)
  const baseUrl = `${url}/api/v1/product`

  async function getTopSellingProducts() {
    setLoading(true)
    try {
      const axios = await LazyAxios()
      const request = await axios.get(`${baseUrl}/getTopSellingProducts/`)
      if (request.data && request.data.data) {
        dispatch(setSuggestedProduct({ 'type': 'top_selling', 'data': request.data.data }))
      }
      setLoading(false)
    }
    catch (error) {
      console.log(error)
      setLoading(false)
    }

  }

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        // Check if the child component is in the viewport
        if (entries[0].isIntersecting && loading) {
          // Trigger the API call or any function passed as prop
          if (top_selling_product === null) {
            getTopSellingProducts()
          }
          else {
            setLoading(false)
          }
        }
      },
      {
        root: null, // default to the viewport
        threshold: intersection_threshold, // 50% of the component must be visible
      }
    );

    if (componentRef.current) {
      observer.observe(componentRef.current);
    }

    return () => {
      if (componentRef.current) {
        observer.unobserve(componentRef.current);
      }
    };
  }, [top_selling_product, loading])


  return (
    <div className='mt-5 container' ref={componentRef}>
      {
        loading ? <ProductPlaceholder /> :
          top_selling_product ? <>
            <div className='h4 heading '>Trending Now : Best-Sellers</div>
            <div style={{ display: 'flex', gap: '30px', width: '100%', marginTop: '50px', overflowX: 'scroll', scrollbarWidth: 'none' }}>
              {
                top_selling_product.map((item, index) => {
                  return <div key={index}>
                    <ProductCard product={item} added={cart_item_list[`p${item.id}`] ? true : false} />
                  </div>
                })
              }
            </div>

            <div className='text-center'><button onClick={() => navigate('/p/shop/all/category/all/products/?s_b=u-s')} className='primaryButton' style={{ width: '130px' }}>See All</button></div>
            <hr className='mt-5' />
          </> : <></>
      }
    </div>
  )
}

export default TopSellingProduct